import type { EditorLabelFormValues } from "./schema-builder-field-editor-label.type";
import type { GetEditorValuesOptions } from "../schema-builder-field-editor.type";
import type { SchemaFieldLabel } from "@/entities/schema";

import {
  getEditorDefaultValues,
  getNewSchemaFieldOptionsFromValues,
  isEditorDefaultFormValuesEqual,
} from "../schema-builder-field-editor-default";

export const getEditorLabelValues = (
  options: GetEditorValuesOptions
): EditorLabelFormValues => {
  return {
    fieldType: "label",
    ...getEditorDefaultValues(options),
  };
};

export const isEditorLabelFormValuesEqual = (
  a: EditorLabelFormValues,
  b: EditorLabelFormValues
) => {
  return isEditorDefaultFormValuesEqual(a, b);
};

export const getNewSchemaLabelFromValues = (
  values: EditorLabelFormValues
): SchemaFieldLabel => {
  return {
    type: "label",
    ...getNewSchemaFieldOptionsFromValues(values),
  };
};
